import { ForwardedRef, forwardRef, PropsWithChildren } from 'react'

import NavigatorAvatar from '@/components/icons/consultations/NavigatorAvatar'
import { cn } from '@/utils/tailwind'

export interface BubbleProps {
  isUser?: boolean
  hideAvatar?: boolean
}

export const Bubble = forwardRef(function Bubble(
  { children, isUser, hideAvatar }: PropsWithChildren<BubbleProps>,
  ref: ForwardedRef<HTMLDivElement>
) {
  return (
    <div
      className={cn('animate-fade-in flex w-full scroll-mt-2 gap-2', isUser ? 'justify-end pr-1' : hideAvatar ? 'pl-10' : 'pl-2', !isUser && 'pr-4')}
      ref={ref}
    >
      {!isUser && !hideAvatar && <NavigatorAvatar className="animate-fade-in text-primary mt-2 h-auto min-w-7 self-start" />}

      {children && (
        <div
          data-testid="navigator-bubble"
          className={cn('rounded-[15px] p-4 shadow-sm', isUser ? `bg-primary-light max-w-[90%] rounded-br-none` : 'bg-white')}
        >
          {children}
        </div>
      )}
    </div>
  )
})
